import { Address } from "@certn/cascadia";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  Modal,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { StripeSetupIntent } from "../stripe/StripeSetupIntent";

interface AddPaymentProfileModalProps {
  defaultAddress?: Address;
  handleClose: () => void;
  includeTitle?: boolean;
  /** Total payment-profile count before this add (API `count`). */
  initialPaymentProfileCount: number;
}

export function AddPaymentProfileModal(props: AddPaymentProfileModalProps) {
  const { handleClose, defaultAddress } = props;
  const { t } = useTranslation();

  return (
    <Modal isOpen testID="add-payment-profile-modal">
      <Dialog width="456px">
        {() => (
          <>
            <DialogHeader onClose={handleClose}>
              {t("Add payment profile")}
            </DialogHeader>
            <DialogContent>
              <StripeSetupIntent
                handleClose={handleClose}
                defaultAddress={defaultAddress}
                initialPaymentProfileCount={props.initialPaymentProfileCount}
              />
            </DialogContent>
          </>
        )}
      </Dialog>
    </Modal>
  );
}
